// The slice variable is the part of the state that you want to get loading from
//  ex. getErrorsFromState('reporting')(state)
import { Map } from 'immutable';

export default function getErrorsFromState(slice) {
  return state => state.getIn([slice, 'data', 'errors'], Map());
}
